import React from 'react';
import PropTypes from 'prop-types';
import ValidationMessage from './ValidationMessage';

class CustomValidation extends React.Component {
  constructor(props) {
    super(props);
    this.state = { isInvalid: false };
  }

  componentDidMount() {
    this.validate();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.value !== this.props.value) {
      this.validate(prevProps.value);
    }
  }

  componentWillUnmount() {
    // Whenever the component is unmount then it needs to let the parent know.
    if (this.props.onValidated) {
      this.props.onValidated(false, null);
    }
  }

  getDefaultMessage() {
    const defaultMessage = (<ValidationMessage controlName={this.props.controlLabel} message="The provided entry is invalid." />);
    const message = this.props.children || defaultMessage;
    return message;
  }

  validate() {
    const isInvalid = this.props.customValidator(this.props.value);
    const message = this.getDefaultMessage();
    const isCritical = this.props.isCritical;
    this.setState({ isInvalid });

    if (this.props.onValidated) {
      this.props.onValidated(isInvalid, message);
    }
    return { isInvalid, message, isCritical };
  }

  render() {
    if (this.props.displayInSummary || !this.state.isInvalid) {
      return null;
    }
    const message = this.getDefaultMessage();
    return (message);
  }
}

CustomValidation.defaultProps = {
  children: null,
  displayInSummary: false,
  isCritical: false
};

CustomValidation.propTypes = {
  controlLabel: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.bool,
    PropTypes.array,
    PropTypes.objectOf(
      PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
        PropTypes.bool,
        PropTypes.array
      ])
    )
  ]).isRequired,
  customValidator: PropTypes.func.isRequired,
  displayInSummary: PropTypes.bool,
  isCritical: PropTypes.bool,
  children: PropTypes.element,
  onValidated: PropTypes.func
};

export default CustomValidation;
